"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagedConnection = void 0;
const Err = __importStar(require("../helpers/errors"));
const utils_1 = require("@streamr/utils");
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const ConnectionManager_1 = require("./ConnectionManager");
const identifiers_1 = require("../identifiers");
const Connection_1 = require("./Connection");
const logger = new utils_1.Logger(module);
// ManagedConnection is a component used as a wrapper for IConnection after they have been successfully handshaked.
// Should only be used in the ConnectionManager.
class ManagedConnection extends eventemitter3_1.default {
    connection;
    connectionId;
    remotePeerDescriptor;
    lastUsedTimestamp = Date.now();
    replacedAsDuplicate = false;
    stopped = false;
    openedAt = Date.now();
    bytesSent = 0;
    bytesReceived = 0;
    messagesSent = 0;
    messagesReceived = 0;
    constructor(peerDescriptor, connection) {
        super();
        this.connectionId = (0, Connection_1.createRandomConnectionId)();
        this.connection = connection;
        connection.on('data', (bytes) => {
            this.lastUsedTimestamp = Date.now();
            this.messagesReceived += 1;
            this.bytesReceived += bytes.length;
            this.emit('managedData', bytes, this.getPeerDescriptor());
        });
        connection.on('disconnected', (gracefulLeave) => this.onDisconnected(gracefulLeave));
        this.lastUsedTimestamp = Date.now();
        this.remotePeerDescriptor = peerDescriptor;
    }
    onDisconnected(gracefulLeave) {
        logger.trace((0, ConnectionManager_1.getNodeIdOrUnknownFromPeerDescriptor)(this.remotePeerDescriptor) + ' onDisconnected() ' + gracefulLeave);
        if (!this.replacedAsDuplicate) {
            this.emit('disconnected', gracefulLeave);
        }
        this.removeAllListeners();
    }
    // TODO: Can this be removed if ManagedConnections can never be duplicates?
    // Handle duplicates in the ConncetorFacade and no longer have PendingConnections in ConnectionManager
    replaceAsDuplicate() {
        logger.trace((0, ConnectionManager_1.getNodeIdOrUnknownFromPeerDescriptor)(this.remotePeerDescriptor) + ' replaceAsDuplicate');
        this.replacedAsDuplicate = true;
    }
    send(data) {
        if (this.stopped) {
            throw new Err.SendFailed('ManagedConnection is stopped');
        }
        this.lastUsedTimestamp = Date.now();
        this.messagesSent += 1;
        this.bytesSent += data.length;
        this.connection.send(data);
    }
    async close(gracefulLeave) {
        if (this.stopped) {
            return;
        }
        await this.connection.close(gracefulLeave);
        this.removeAllListeners();
    }
    getNodeId() {
        return (0, identifiers_1.toNodeId)(this.remotePeerDescriptor);
    }
    getLastUsedTimestamp() {
        return this.lastUsedTimestamp;
    }
    getPeerDescriptor() {
        return this.remotePeerDescriptor;
    }
    getDiagnosticInfo() {
        return {
            remotePeerDescriptor: this.remotePeerDescriptor,
            lastUsedTimestamp: this.lastUsedTimestamp,
            replacedAsDuplicate: this.replacedAsDuplicate,
            stopped: this.stopped,
            openedAt: this.openedAt,
            bytesSent: this.bytesSent,
            bytesReceived: this.bytesReceived,
            messagesSent: this.messagesSent,
            messagesReceived: this.messagesReceived
            // Add connection type?
        };
    }
}
exports.ManagedConnection = ManagedConnection;
//# sourceMappingURL=ManagedConnection.js.map